import authEn from "./en.json";
import de from './de.json';

const authLocales = {
  en: authEn,
  de: de
};

export default authLocales;
